module.exports = __webpack_public_path__ + "static/media/meditation1.7a168bca.mp3";